var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseLayout',[_c('SContainerRow',[_c('SContainerColumn',[_c('Nuxt')],1),_vm._v(" "),_c('SContainerColumn',{attrs:{"size":"md","narrow":""}},[_c('TheSidebar')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }